export const ENV = {
  API_URL: process.env.NODE_ENV === 'production'
    ? 'https://api.explanatum.co.uk'  // Production API URL on your VPS
    : (process.env.REACT_APP_API_URL?.trim() || 'http://localhost:5000'),
  API_TIMEOUT: 30000,
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000,
  NODE_ENV: process.env.NODE_ENV || 'development'
};

export default ENV;
